import React from 'react';

const Sidebar = ({ children, className = '' }) => {
    return <div className={`dm-sidebar ${className}`}>{children}</div>;
};

export { Sidebar };
